<template>
  <div>
    <warehouse-handling-tabs></warehouse-handling-tabs>
    <v-card class="white rounded-lg">
      <v-card-title class="secondary--text">{{title}}</v-card-title>
      <v-card-text>
        <m-datatable
            :headers="headers"
            :apiUrl="url"
            :filters.sync="filters"
            ref="datatable"
            @dblclick:row="(e, row) => $router.push(to(row.item))"
        >
          <template #item.detail="{ item }">
            <detail-link :to="to(item)"/>
          </template>
        </m-datatable>
      </v-card-text>
    </v-card>
  </div>

</template>

<script>
import WarehouseHandlingTabs from "@/views/panel/warehouseHandling/WarehouseHandlingTabs";

export default {
  name: "WarehouseHandlingList",
  components: {WarehouseHandlingTabs},
  props: {
    type: {},
  },
  data() {
    return {
      filters: {},
      url: "reports/lists/warehouseHandlings",
    };
  },
  computed: {
    title(){
      return this.setDocumentTitle('لیست انبار گردانی ها')
    },
    headers() {
      let headers = [
        {
          text: "شماره",
          value: "code",
        },
        {
          text: "تاریخ آغاز",
          value: "start_date",
        },
        {
          text: "تاریخ شمارش",
          value: "counting_date",
        },
        {
          text: "تاریخ ثبت انبارگردانی",
          value: "submit_date",
        },
        {
          text: "انبار گردان",
          value: "handler_name",
        },
        {
          text: "انبار",
          value: "warehouse.title",
        },
        {
          text: "قطعی",
          value: "is_defined",
          type: "boolean",
        },
        {
          text: "توضیحات",
          value: "explanation",
        },
      ];

      headers.push({
        text: "جزئیات",
        value: "detail",
        sortable: false,
        filterable: false,
      });

      return headers;
    },
  },
  created() {
    this.filters.type = this.type;
  },
  watch: {
    $route() {
      this.$refs.datatable.getDataFromApi();
      this.filters.type = this.type;
    },
  },
  methods: {
    to(item) {
      return {
        name: "WarehouseHandlingForm",
        params: {
          id: item.id,
        },
      };
    },
  },
};
</script>

<style scoped lang="scss"></style>
